'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DeviceSetupCast = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactIntl = require('react-intl');

var _reactInlinesvg = require('react-inlinesvg');

var _reactInlinesvg2 = _interopRequireDefault(_reactInlinesvg);

var _bluetooth = require('constants/bluetooth');

var _bluetooth2 = _interopRequireDefault(_bluetooth);

var _interactive = require('helpers/interactive');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeviceSetupCast = exports.DeviceSetupCast = function (_React$Component) {
  (0, _inherits3.default)(DeviceSetupCast, _React$Component);

  function DeviceSetupCast(props) {
    (0, _classCallCheck3.default)(this, DeviceSetupCast);

    var _this = (0, _possibleConstructorReturn3.default)(this, (DeviceSetupCast.__proto__ || (0, _getPrototypeOf2.default)(DeviceSetupCast)).call(this, props));

    _this.handleBrowserPlay = _this.handleBrowserPlay.bind(_this);
    _this.handleCastClick = _this.handleCastClick.bind(_this);
    _this.handleConnectionChange = _this.handleConnectionChange.bind(_this);
    _this.renderTop = _this.renderTop.bind(_this);
    _this.renderBody = _this.renderBody.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(DeviceSetupCast, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (global.cast && global.cast.framework) {
        var castContext = global.cast.framework.CastContext.getInstance();
        castContext.removeEventListener(global.cast.framework.CastContextEventType.CAST_STATE_CHANGED, this.handleConnectionChange);
      }
    }
  }, {
    key: 'handleConnectionChange',
    value: function handleConnectionChange(state) {
      var onToggleHide = this.props.onToggleHide;


      if (state.castState === global.cast.framework.CastState.CONNECTING) {
        onToggleHide(false);
      }
    }
  }, {
    key: 'handleCastClick',
    value: function handleCastClick() {
      var _props = this.props,
          alias = _props.alias,
          localJoinClass = _props.joinClass,
          hideModal = _props.hideModal,
          status = _props.status,
          updateDevice = _props.updateDevice;


      if (global.cast && global.cast.framework) {
        var castContext = global.cast.framework.CastContext.getInstance();
        castContext.addEventListener(global.cast.framework.CastContextEventType.CAST_STATE_CHANGED, this.handleConnectionChange);
        updateDevice({ status: _bluetooth2.default.ATTEMPTING_TO_CAST });

        castContext.requestSession().then(function () {
          hideModal('DeviceSetupModal');
          localJoinClass(alias);
        }).catch(function (e) {
          if (status === _bluetooth2.default.ATTEMPTING_TO_CAST || e === 'session_error') {
            hideModal('DeviceSetupModal');
          }
        });
      }
    }
  }, {
    key: 'handleBrowserPlay',
    value: function handleBrowserPlay() {
      var _props2 = this.props,
          alias = _props2.alias,
          localJoinClass = _props2.joinClass,
          hideModal = _props2.hideModal;


      localJoinClass(alias);

      global.BitmovinPlayer.play('ui');
      hideModal('DeviceSetupModal');
    }
  }, {
    key: 'renderTop',
    value: function renderTop(availableCastDevices) {
      var status = this.props.status;


      if (status === _bluetooth2.default.ATTEMPTING_TO_CAST) {
        return _react2.default.createElement(
          'div',
          { className: 'modal__device-setup__top' },
          _react2.default.createElement(
            'h3',
            null,
            _react2.default.createElement(_reactIntl.FormattedMessage, {
              id: 'device.casting-header',
              defaultMessage: 'Casting to TV'
            })
          )
        );
      }

      return availableCastDevices ? _react2.default.createElement(
        'div',
        { className: 'modal__device-setup__top' },
        _react2.default.createElement(
          'h3',
          null,
          _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'device.cast-header',
            defaultMessage: 'Cast this class to your TV'
          })
        ),
        _react2.default.createElement(_reactIntl.FormattedMessage, {
          id: 'device.header-p',
          defaultMessage: 'Click the button below to cast this class to your TV. Be sure to select the correct input on your TV.',
          tagName: 'p'
        })
      ) : _react2.default.createElement(
        'div',
        { className: 'modal__device-setup__top' },
        _react2.default.createElement(
          'h3',
          null,
          _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'device.no-devices-header',
            defaultMessage: 'No Chromecast devices found'
          })
        ),
        _react2.default.createElement(_reactIntl.FormattedMessage, {
          id: 'device.no-devices-p',
          defaultMessage: 'We couldn\'t find any Chromecast devices on your network. Make sure Wi-Fi is on and your Chromecast is connected to the same network.',
          tagName: 'p'
        })
      );
    }
  }, {
    key: 'renderBody',
    value: function renderBody(availableCastDevices) {
      var status = this.props.status;


      if (status === _bluetooth2.default.ATTEMPTING_TO_CAST) {
        return _react2.default.createElement(
          'div',
          { className: 'modal__device-setup__content' },
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement('img', { src: require('../../../static/img/icon/chromecast/casting.gif'), alt: 'Cast' }),
            _react2.default.createElement(
              'p',
              { className: 'mt-' },
              _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'device.watch.on-tv',
                defaultMessage: 'Casting to your TV...'
              })
            )
          )
        );
      }

      return _react2.default.createElement(
        'div',
        { className: 'modal__device-setup__content' },
        _react2.default.createElement(
          'button',
          {
            className: (0, _classnames2.default)('bt bt--primary bt--width-md modal__device-cast__bt', {
              'modal__device-cast__bt--disabled': !availableCastDevices
            }),
            onClick: this.handleCastClick
          },
          _react2.default.createElement(_reactInlinesvg2.default, { src: require('../../../static/img/icon/chromecast/chromecast-empty.svg'), className: 'modal__device-cast__cast-logo mr-' }),
          _react2.default.createElement(
            'span',
            { className: 'modal__device-cast__cast-text' },
            'Cast to TV'
          )
        ),
        _react2.default.createElement(
          'p',
          { className: 'modal__device-cast__reminder mv' },
          _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'device.or',
            defaultMessage: 'or'
          })
        ),
        _react2.default.createElement(
          'button',
          { className: 'bt bt--oultine bt--mkt-white bt--width-md mb', onClick: this.handleBrowserPlay },
          _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'device.watch.browser',
            defaultMessage: 'Watch in browser'
          })
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var availableCastDevices = (0, _interactive.isChromecastDeviceAvailable)();

      return _react2.default.createElement(
        'div',
        { className: 'modal__device-cast' },
        this.renderTop(availableCastDevices),
        this.renderBody(availableCastDevices)
      );
    }
  }]);
  return DeviceSetupCast;
}(_react2.default.Component);

DeviceSetupCast.propTypes = {
  alias: _propTypes2.default.string,
  hideModal: _propTypes2.default.func,
  joinClass: _propTypes2.default.func,
  onToggleHide: _propTypes2.default.func,
  status: _propTypes2.default.string,
  updateDevice: _propTypes2.default.func
};